/**
 * Public-facing app origin for QR codes and share links.
 * Set REACT_APP_PUBLIC_URL in production (e.g. https://mylegacybridge.com).
 */
export function getPublicAppUrl() {
  const envUrl = (process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_FRONTEND_URL || '').trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return 'http://localhost:3000';
}

export function memorialQrPath(shortCode) {
  return `/q/${encodeURIComponent(shortCode)}`;
}

export function memorialQrPublicUrl(shortCode) {
  if (!shortCode) return null;
  return `${getPublicAppUrl()}${memorialQrPath(shortCode)}`;
}
